// extracted by mini-css-extract-plugin
module.exports = {"svg":"style_svg__1YX7v","needsAttentionPulse":"style_needsAttentionPulse__1Q3fY"};